import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'processoSei'
})
export class ProcessoSeiPipe implements PipeTransform {

  transform(value: string, args?: any): any {
    if (value !== undefined && value.trim().length === 20) {
      value = value.replace(/(\d{3})(\d{4})(\d{4})(\d{7})(\d{2})/g, '\$1.\$2.\$3.\$4\-\$5');
    } else if (value !== undefined && value.trim().length === 21) {
      value = value.replace(/(\d{3})(\d{5})(\d{4})(\d{7})(\d{2})/g, ' \$1.\$2.\$3.\$4\-\$5');
    } 
     return value;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipe/processo-sei.pipe.ts